import { createSelector } from 'reselect';

import { configSelector } from './config';

const ossConfigSelector = createSelector(
  configSelector,
  (config) => config.oss || {}
);

export const ossAccessRestrictedCodesSelector = createSelector(
  ossConfigSelector,
  (ossConfig) => ossConfig.access_restricted_codes || []
);
